(function(){
	var WP_theme = kelQuartierAjax.WP_theme;
	var dossierAssets = WP_theme + "/dist/";

	var map;
	var TabData = {};
	var sousCat_ids;

	var TabDataMarker = {};

	var bAvecInfo = true;

	var idLastMarker = null;
	var movingMap = false;

	function initTabData(){
		//Lien les icones sur la carte
		TabData.poi_aeroport = {text: "aéroprts", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Aeroport_01.08676d8d.png"};
		TabData.poi_bus = {text: "bus", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Bus_01.22818287.png"};
		TabData.poi_autolib = {text: "autolib'", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Autolib_01.7f29296d.png"};
		TabData.poi_gare_ferroviaire = {text: "gares ferroviaires", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Gare-RER_01.cdb917b8.png"};
		TabData.poi_location_velo = {text: "locations de vélo", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Velo_01.46a8b1d5.png"};
		TabData.poi_metro = {text: "métros", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Metro_01.d2cad130.png"};
		TabData.poi_parking = {text: "parkings", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Parking_01.bfc0dc12.png"};
		TabData.poi_parking_velo = {text: "parkings à vélo", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_ParkingVelo_01.1c3e94f5.png"};
		TabData.poi_rer = {text: "rer", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Gare-RER_01.cdb917b8.png"};
		TabData.poi_taxi = {text: "stations de taxi", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Taxi_01.5885a2cd.png"};
		TabData.poi_essence = {text: "pompes à essence", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_StationService_01.7ba7fd51.png"};
		TabData.poi_ferry = {text: "terminaux de ferry", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Ferry_01.2441950c.png"};
		TabData.poi_tramway = {text: "tramways", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Tram_01.35d01786.png"};
		TabData.poi_velib = {text: "vélib'", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Velib_01.214a272b.png"};
		TabData.poi_banque = {text: "banques", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Banque_01.3256ef6a.png"};
		TabData.poi_bar = {text: "bars", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Bar_01.f3b66c66.png"};
		TabData.poi_boucherie = {text: "bouchers", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Boucher_01.8012f963.png"};
		TabData.poi_boulangerie = {text: "boulangeries", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Boulangerie_01.50e2b4ae.png"};
		TabData.poi_poste = {text: "bureaux de poste", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_BureauPoste_01.c590f6e6.png"};
		TabData.poi_marche = {text: "marchés de quartier", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Marche_01.dbca1ad5.png"};
		TabData.poi_presse_tabac = {text: "maisons de presse et tabac", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Presse_01.479ae909.png"};
		TabData.poi_restaurant = {text: "restaurants", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Restaurant_01.cc41ed91.png"};
		TabData.poi_superette = {text: "supérettes", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Superette_01.2c636953.png"};
		TabData.poi_super_hyper = {text: "supermarchés et hypermarchés", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Supermarche_01.839c2d1c.png"};
		TabData.poi_bibliotheque = {text: "bibliothèques", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Bibliotheque_01.98ea0125.png"};
		TabData.poi_monument = {text: "monuments historique", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Monument_01.ffaaa4a6.png"};
		TabData.poi_theatre = {text: "théâtres", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Theatre_01.118af6ab.png"};
		TabData.poi_casino = {text: "casinos", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Casino_01.3cf9d70f.png"};
		TabData.poi_cinema = {text: "cinémas", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Cinema_01.fa811d16.png"};
		TabData.poi_parc = {text: "parcs, jardins et squares", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Parc_01.c444aaf2.png"};
		//TabData.poi_plage = {text: "plages et baignades", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_piscine_01.png"};
		TabData.poi_sport = {text: "lieux de sport", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Sport_01.4864f61c.png"};

		TabData.poi_college = {text: "collèges", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Education_01.61b8211e.png"};
		TabData.poi_maternelle = {text: "écoles maternelles", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Education_01.61b8211e.png"};
		TabData.poi_primaire = {text: "écoles primaires", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Education_01.61b8211e.png"};
		TabData.poi_ens_superieur = {text: "lieux d'enseignement supérieur", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Education_01.61b8211e.png"};
		TabData.poi_lycee = {text: "lycées", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Education_01.61b8211e.png"};

		TabData.poi_camping = {text: "camping", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Camping_01.c62a843e.png"};
		TabData.poi_hotel = {text: "hôtels", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Hotel_01.7285a244.png"};
		TabData.poi_tourisme = {text: "résidences de tourisme, villages et parcs", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_PointdeVue_01.f7e765ed.png"};
		TabData.poi_hopital = {text: "hôpitaux", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Hopital_01.f060f92c.png"};
		TabData.poi_med_generaliste = {text: "médecins généralistes", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Medecin_01.1d3cbc79.png"};
		TabData.poi_med_specialiste = {text: "médecins spécialistes", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Medecin_01.1d3cbc79.png"};
		TabData.poi_pharmacie = {text: "pharmacies", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Pharmacie_01.fdf26e03.png"};
		TabData.poi_creche = {text: "crèches", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Creche_01.e67387db.png"};
		TabData.poi_ludotheque = {text: "ludothèques", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Ludotheque_01.3a228d02.png"};
		TabData.poi_caf = {text: "Caf", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Services_Publiques_loi_01.ed148a17.png"};
		TabData.poi_cpam = {text: "Cpam", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Services_Publiques_loi_01.ed148a17.png"};
		TabData.poi_gendarmerie = {text: "gendarmeries", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Gendarmerie_01.94fb9388.png"};
		TabData.poi_mairie = {text: "mairies", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Mairie_01.9a43c18b.png"};
		TabData.poi_pole_emploi = {text: "pôles emploi", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Services_Publiques_loi_01.ed148a17.png"};
		TabData.poi_police = {text: "poste de police", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_police_01.png"};
		TabData.poi_impot_entreprise = {text: "impôts des entreprises", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Services_Publiques_loi_01.ed148a17.png"};
		TabData.poi_impot_particulier = {text: "impôts des particuliers", nb: 0, icon: dossierAssets + "images/kelquartier/Pin_Services_Publiques_loi_01.ed148a17.png"};

		sousCat_ids = {
			49: "poi_banque",
			2: "poi_bar",
			4: "poi_boucherie",
			5: "poi_boulangerie",
			27: "poi_poste",
			19: "poi_marche",
			50: "poi_presse_tabac",
			26: "poi_restaurant",
			30: "poi_superette",
			29: "poi_super_hyper",
			12: "poi_bibliotheque",
			13: "poi_monument",
			31: "poi_theatre",
			6: "poi_college",
			7: "poi_maternelle",
			8: "poi_primaire",
			9: "poi_ens_superieur",
			10: "poi_lycee",
			18: "poi_casino",
			3: "poi_cinema",
			15: "poi_parc",
			14: "poi_sport",
			63: "poi_creche",
			47: "poi_ludotheque",
			17: "poi_hopital",
			35: "poi_med_generaliste",
			36: "poi_med_specialiste",
			25: "poi_pharmacie",
			56: "poi_caf",
			58: "poi_cpam",
			59: "poi_gendarmerie",
			48: "poi_mairie",
			60: "poi_pole_emploi",
			57: "poi_police",
			61: "poi_impot_entreprise",
			62: "poi_impot_particulier",
			52: "poi_camping",
			51: "poi_hotel",
			54: "poi_tourisme",
			64: "poi_aeroport",
			1: "poi_bus",
			46: "poi_autolib",
			16: "poi_gare_ferroviaire",
			33: "poi_location_velo",
			20: "poi_metro",
			23: "poi_parking",
			24: "poi_parking_velo",
			65: "poi_rer",
			28: "poi_taxi",
			32: "poi_essence",
			21: "poi_ferry",
			22: "poi_tramway",
			34: "poi_velib"
		};
	}

	function initTabMarker() {
		TabDataMarker = [];
	}

	function refreshDatas() {
		nettoieCarte();
		initTabMarker();
		var Selection = document.querySelectorAll("input[id^=chk_poi_]:checked");
		var schaineCat = [];

		for(var i in Selection) {
			if(Selection.hasOwnProperty(i)) {
				schaineCat.push(Selection[i].getAttribute("data-theme"));
			}
		}
		schaineCat = schaineCat.join(",");
		getPOI(schaineCat,"");

		movingMap = false;
	}


	function onPoiChange() {
		if (this.checked === true) {
			getPOI(this.getAttribute("data-theme") || "", this.getAttribute("data-theme-2") || "");
		} else {
			nettoieCategorie(this.getAttribute("data-theme"));
		}
	}

	// fonction d'appel au serveur pour récupérer les POI désirés
	function getPOI(id_theme_1, id_theme_2, recup_nombre_poi) {
		if (recup_nombre_poi === undefined) {
			recup_nombre_poi = 0;
		}

		// récupération des contours de la carte
		var oLatLngBounds = map.getBounds();
		var oLatLngNorthEast = oLatLngBounds.getNorthEast();
		var oLatLngSouthWest = oLatLngBounds.getSouthWest();

		//var url = WP_theme + "/lib/recuperationPOI.php";
		var url = kelQuartierAjax.ajaxurl,
		nonce = kelQuartierAjax.security;

		var data = [
			"action=recuperation_poi",
			"security=" + nonce,
			"theme=" + id_theme_1,
			"theme2=" + id_theme_2,
			"max_lon=" + oLatLngNorthEast.lng,
			"min_lon=" + oLatLngSouthWest.lng,
			"max_lat=" + oLatLngNorthEast.lat,
			"min_lat=" + oLatLngSouthWest.lat,
			"format=json",
			"cpt=" + recup_nombre_poi
		];

		var request = new XMLHttpRequest();
		request.open("POST", url);
		request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		request.overrideMimeType("text/plain; charset=UTF-8");
		request.send(data.join("&"));

		request.addEventListener('load', function(){
			if (200 === this.status) {
				var json = JSON.parse(this.response)
				// console.log(json);
				var infos = json.data;

				if (id_theme_1 !== '') {
					separePOI(infos, id_theme_1);
				} else if( id_theme_2 !== "") {
					separePOI(infos);
				}
				//Permet de réafficher l'infobulle du markeur si celui-ci est encore affiché à l'écran
				if (idLastMarker !== null) {
					actualiseInfoBulle();
				}
			} else {
				console.log('fail | status : ' + this.status + ' | response : ' + this.response);
			}

		});
	}

	function separePOI(infos, idCat) {
		if (idCat === undefined) {
			idCat=null;
		}
		for (var i in infos) {
			if (!infos.hasOwnProperty(i)) {
				continue;
			}
			if (infos[i].id_theme_2 !== undefined && sousCat_ids[infos[i].id_theme_2] !== undefined) {
				creationMarker(infos[i], sousCat_ids[infos[i].id_theme_2]);
			}
		}
	}

	function creationMarker(oObjet, id_picto){
		if (TabDataMarker[oObjet.id_theme_1] === undefined || TabDataMarker[oObjet.id_theme_1] === null) {
			TabDataMarker[oObjet.id_theme_1] = [];
		}

		var sTitre = oObjet.nom + '\n' + oObjet.theme_2;

		// on créé le marker
		var oMarker = L.marker([oObjet.lat, oObjet.lon], {
			icon: L.icon({
				'iconUrl': TabData[id_picto].icon,
				'popupAnchor': [15, 0]
			}),
			title: sTitre
		}).addTo(map);

		//On prépare le contenu de l'info bulle
		if (bAvecInfo) {
			var sAffichage = "<div class=\"styleInfoWindow\">" + oObjet.nom + "<br>" + oObjet.theme_2;

			if (oObjet.info_1.replace(/[\s\t\n\r]+/g,"") !== "") {
				sAffichage += "<br>" + oObjet.info_1;
			}
			if(oObjet.info_2.replace(/[\s\t\n\r]+/g,"") !== "") {
				sAffichage += "<br>" + oObjet.info_2;
			}
			if(oObjet.info_3.replace(/[\s\t\n\r]+/g,"") !== "") {
				sAffichage += "<br>" + oObjet.info_3;
			}
			if(oObjet.info_4.replace(/[\s\t\n\r]+/g,"") !== "") {
				sAffichage += "<br>" + oObjet.info_4;
			}
			sAffichage += "</div>";
			oMarker.Affichage = sAffichage;
		} else {
			oMarker.Affichage = "<div class=\"styleInfoWindow\">" + oObjet.nom + "<br>" + oObjet.theme_2 + "</div>";
		}

		oMarker.idPoi = oObjet.id;

		//On se met à l'écoute des clics pour afficher des infos
		var popup = L.popup({
			'autoPan': false
		}).setContent(oMarker.Affichage);
		oMarker.bindPopup(popup);
		oMarker
		.on('popupopen', openPopup)
		.on('popupclose', closeMarker)
		;

		// on stocke le type du marker (quel type de POI) pouvoir les effacer selon type
		oMarker.sType = id_picto;

		// on stocke le marker dans un tableau global afin de pouvoir les effacer
		TabDataMarker[oObjet.id_theme_1].push(oMarker);
	}

	function nettoieCategorie(idCat) {
		if (TabDataMarker[idCat]!== undefined) {
			for (var i in TabDataMarker[idCat]) {
				if (TabDataMarker[idCat].hasOwnProperty(i)) {
					TabDataMarker[idCat][i].remove();
				}
			}
			TabDataMarker[idCat] = null;
		}
	}

	function nettoieCarte(){
		for (var idCat in TabDataMarker) {
			if (TabDataMarker.hasOwnProperty(idCat)) {
				for (var i in TabDataMarker[idCat]) {
					if (TabDataMarker[idCat].hasOwnProperty(i)) {
						TabDataMarker[idCat][i].remove();
					}
				}
			}
		}
	}

	function actualiseInfoBulle(){
		// console.log("LAST = "+idLastMarker.lat()+" "+idLastMarker.lng());
		for (var idCat in TabDataMarker) {
			if (!TabDataMarker.hasOwnProperty(idCat)) {
				continue;
			}
			for (var i in TabDataMarker[idCat]) {
				// console.log(idLastMarker + " =? " + TabDataMarker[idCat][i].idPoi);
				// console.log("lat = " + TabDataMarker[idCat][i].idPoi.lat() + " long = " + TabDataMarker[idCat][i].idPoi.lng());
				if (TabDataMarker[idCat].hasOwnProperty(i) && TabDataMarker[idCat][i].idPoi === idLastMarker) {
					var marker = TabDataMarker[idCat][i];
					marker.getPopup().setContent(TabDataMarker[idCat][i].Affichage);
					marker.openPopup();
					return;
				}
			}
		}
		idLastMarker = null;
	}

	function openPopup(e) {
		if (e.popup && e.sourceTarget) {
			idLastMarker = e.sourceTarget.idPoi;
		}
	}

	function closeMarker( ){
		if (movingMap === false) {
			idLastMarker = null;
		}
	}

	function initialize() {

		initTabData();

		var mapNode = document.querySelector('#maps'),
		markerPos = null,
		lat = "",
		lng = "",
		zoom = 13,
		precision = 2500;

		markerPos = JSON.parse(mapNode.getAttribute('data-maps'));
		lat = markerPos.lat;
		lng = markerPos.lng;
		precision = undefined === markerPos.precision ? precision : markerPos.precision;

		if ( undefined == markerPos.zoom ) {
			if ( 750 == precision || 'agence' == precision ) {
				zoom = 14;
			} else if ( 250 == precision ) {
				zoom = 15;
			}
		} else {
			zoom = markerPos.zoom;
		}

		if (typeof lat === 'string' && lat !== '' && typeof lng === 'string' && lng !== '') {
			L.Map.addInitHook('addHandler', 'gestureHandling', leafletGestureHandling.GestureHandling);

			// Création de l'objet MAP avec par défaut un zoom à 17 et le LngLat que vous désirez
			var mapOptions = {
				zoom: zoom,
				center: L.latLng(lat, lng),
				gestureHandling: true,
				gestureHandlingOptions: {
					duration: 1500
				}
			};

			map = L.map('maps', mapOptions);

			var osm = new L.TileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
			});
			map.addLayer(osm);

			L.control.scale().addTo(map);

			if ( 'agence' === precision ) {
				L.marker([lat, lng], {
					icon: L.icon({
						iconUrl: dossierAssets + '/images/bulleK.d02262b2.png',
						iconSize: [32, 44],
						iconAnchor: [16, 44], // ancre sur top-center left par défaut
						tooltipAnchor: [15, 0],
						popupAnchor: [0, -44]
					}),
					zIndex: 999
				})
				.addTo(map);
			} else {
				L.circle([lat, lng], {
					color: '#27326F',
					fillColor: '#CACEE1',
					fillOpacity: 0.5,
					radius: precision
				}).addTo(map);
			}
		}

		// Écouteur sur le changement de cadrage de la carte
		map.on('movestart', function () {
			movingMap = true;
		});
		map.on('moveend', refreshDatas);

		// Écouteur sur les checkbox des POIs
		var checkboxes_poi = document.querySelectorAll('.poi input');
		for (var i in checkboxes_poi) {
			if ( !checkboxes_poi.hasOwnProperty(i) ) {
				continue;
			}
			checkboxes_poi[i].addEventListener('change', onPoiChange);
		}
	}
	document.addEventListener('DOMContentLoaded', initialize);
})();
